/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './round-switcher.stache';

Component.extend({
    tag: 'round-switcher',
    template: template,
    leakScope: false,
    showDisabled: true,
    viewModel: {
        round: null,
        define: {
            maxRounds: {
                type: 'number',
                value: 4,
            },
            currentRound: {
                type: 'number',
                value: null,
            },
            round: {
                // holds internal round index
                type: 'number',
                value: null,
            },
            roundsInfo: {
                Type: can.List,
                value: null,
            },
            roundsCount: {
                get() {
                    const count =
                        this.attr('currentRound') ||
                        this.attr('roundsInfo.length') ||
                        null;

                    if (count !== null) {
                        // select last round with data by default or select last round if the number of rounds decreased
                        if (
                            this.attr('round') === null ||
                            this.attr('roundsInfo.length') < this.attr('round')
                        ) {
                            this.attr('round', count);
                        }

                        return count;
                    }

                    return 0;
                },
            },
        },
    },
    events: {
        '.s-switcher-btn click'($el) {
            if (!$el.hasClass('is-disabled')) {
                let roundIndex = parseInt($el.attr('data-round-number'));
                this.viewModel.attr('round', roundIndex);
                // move drawer render in the next tick for better usability
                setTimeout(() => this.viewModel.attr('round', roundIndex), 16);
            }
        },

        '.s-round-switcher-mobile change'() {
            const roundIndex = this.viewModel.round;
            // move drawer render in the next tick for better usability
            setTimeout(() => this.viewModel.attr('round', roundIndex), 16);
        },
    },
});
